<template>
  <!-- Not a live region itself: the fuller announcement goes through the map's polite
       live region, so screen readers hear it once. -->
  <div v-if="message" :class="['otm-toast', { 'otm-toast--plain': !undo }]">
    <span class="otm-toast-message">{{ message }}</span>
    <button
      v-if="undo"
      type="button"
      class="otm-toast-undo"
      @click="$emit('undo')"
      @keydown.esc.prevent
    >
      {{ $t('map.on_this_map_control.undo') }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OnThisMapToast',
  props: {
    message: { type: String, default: '' },
    undo: { type: Boolean, default: false },
  },
  emits: ['undo'],
});
</script>

<style scoped>
.otm-toast {
  position: absolute;
  left: 50%;
  bottom: 44px;
  transform: translateX(-50%);
  z-index: 1001;
  display: flex;
  align-items: center;
  gap: 8px;
  width: max-content;
  max-width: calc(100% - 24px);
  min-height: 44px;
  padding: 0 4px 0 16px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #22242A;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  color: #fff;
  font-size: 14px;
  line-height: 1.3;
}

.otm-toast-message {
  padding: 10px 0;
}

.otm-toast--plain {
  padding-right: 16px;
}

.otm-toast-undo {
  flex: none;
  min-height: 44px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: none;
  color: #FDDF00;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.otm-toast-undo:hover {
  text-decoration: underline;
}

.otm-toast-undo:focus {
  outline: none;
}

.otm-toast-undo:focus-visible {
  outline: 2px solid #FDDF00;
  outline-offset: -2px;
}
</style>
